import apiCaller from '../../utils/apiCaller';
import urlHelper from '../../utils/url';
import errorHandler from '../Common/ErrorHandler';

export const AITOOLS_LOADING = 'AITOOLS_LOADING',
  AITOOLS_LIST = 'AITOOLS_LIST',
  AITOOLS_PROMPTS_LIST = 'AITOOLS_PROMPTS_LIST';

export function handleError(error) {
  return errorHandler.setError(error);
}

export function getAiPrompts(opt = {}) {
  return (dispatch) => {
    dispatch({ type: AITOOLS_LOADING });

    let url = 'prompts';
    url += urlHelper.buildQuery(opt);

    apiCaller
      .api(url, 'get')
      .then((res) => {
        if (opt.page === 'all') {
          dispatch({
            type: AITOOLS_PROMPTS_LIST,
            payload: res,
          });
        } else {
          dispatch({
            type: AITOOLS_LIST,
            payload: res,
          });
        }
      })
      .catch((err) => {
        dispatch(errorHandler.setError(err));
      });
  };
}

export function createAiPrompt(model) {
  return (dispatch) => {
    dispatch({ type: AITOOLS_LOADING });
    apiCaller
      .api('prompts', 'post', model)
      .then(() => {
        dispatch(getAiPrompts());
      })
      .catch((err) => {
        dispatch(errorHandler.setError(err));
      });
  };
}

export function updateAiPrompt(id, model) {
  return (dispatch) => {
    dispatch({ type: AITOOLS_LOADING });
    apiCaller
      .api(`prompts/${id}`, 'put', model)
      .then(() => {
        dispatch(getAiPrompts());
      })
      .catch((err) => {
        dispatch(errorHandler.setError(err));
      });
  };
}
